<template>
    <Modal class-name="scrollable vertical-center-modal" title="Actualizar RI" v-model="show" :footer-hide="true" :scrollable="true">
        <Form style="width: 100%" ref="planForm" :model="plan" :rules="ruleInline">
            <Row :gutter="16">
                <i-col span="24">
                    <FormItem label="RI" prop="text">
                        <Input type="textarea" :autosize="{minRows: 5,maxRows: 8}" v-model="plan.text" placeholder="RI"/>
                    </FormItem>
                </i-col>
                <i-col span="24">
                    <Button style="margin-top: 25px" size="large" long type="primary" :loading="loading" @click="save">Guardar</Button>
                </i-col>
            </Row>
        </Form>
    </Modal>
</template>

<script>
    export default {
        data(){
            return {
                show: false,
                plan: {
                    i: null,
                    text: ""
                },
                loading: false,
                ruleInline: {
                    text: [
                        { required: true, message: 'RI es requerido', trigger: 'change' }
                    ],
                },
            }
        },
        methods: {
            save(){
                this.$refs.planForm.validate(valid => {

                    if(valid){
                        this.loading = true
                        window.axios.post(this.$root.API_URL + '/strategic-plan/update-ri', { id: this.$parent.plans[0].id, ...this.plan })
                        .then(response => {
                            if(response.data.success){
                                window.EventBus.$emit('strategic-plan--update-plan', response.data.plan)
                                this.show = false
                                this.loading = false
                            }
                        })
                    }
                })
            }
        },
        mounted(){
            window.EventBus.$on('strategic-plan--update-ri', (index, text) => {
                this.plan.i = index
                this.plan.text = text
                this.show = true
            })
        }
    }
</script>